import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import PropsType from 'prop-types';

import { useStore } from '~/hooks';
import { useSelector } from '~/hooks/useSelector';
import { setAuthLoading, UserSelect } from '~/store/user';
import Notification from '../../components/Notification';
import { logoGif } from '~/assets/images';
import Button, { ButtonClose } from '../../components/Button';
import styles from './Login.module.scss';

const cx = classNames.bind(styles);

function Login({ onClose, changePage }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [alert, setAlert] = useState({ message: '', severity: 'info' });

    const authLoadingStatus = useSelector(UserSelect.getAuthLoadingStatus);
    const { login, user } = useStore();
    const [, userDispatch] = user;

    //delay loading screen before reload page
    useEffect(() => {
        if (authLoadingStatus === false) return; //avoid run useEffect when component mounted
        const timer = setTimeout(() => {
            userDispatch(setAuthLoading({ status: false }));
        }, 6000);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [authLoadingStatus]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setAlert({ ...alert, message: '' });

        try {
            userDispatch(setAuthLoading({ status: true }));
            await login(email, password);
            await onClose();
            window.location.reload();
        } catch (error) {
            setAlert({ ...alert, message: 'Correo o contraseña incorrectos', severity: 'error' });
            userDispatch(setAuthLoading({ status: false }));
            console.log(error.message);
        }
    };
    return (
        <div className={cx('wrapper', 'fade-in')}>
            {alert.message && (
                <Notification
                    open={!!alert.message}
                    severity={alert.severity}
                    message={alert.message}
                    onClose={() => setAlert({ ...alert, message: '' })}
                />
            )}

            <ButtonClose className={cx('pos')} onClick={onClose} />
            <div className={cx('login-form')}>
                <img src={logoGif} alt="logo" className={cx('logoGif')} />
                <h1 className={cx('greeting')}>¡Bienvenido de nuevo!</h1>
                <h4>Inicia sesión en tu cuenta</h4>
                <form action="" id="form" onSubmit={handleSubmit}>
                    <div className={cx('form-container')}>
                        <div className={cx('form-group')}>
                            <div className={cx('form-control')}>
                                <input
                                    required
                                    id="email"
                                    placeholder="Correo electrónico"
                                    className={cx('login-input', 'separator')}
                                    type="text"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                                <div />
                            </div>
                            <div className={cx('form-control')}>
                                <input
                                    required
                                    id="password"
                                    placeholder="Contraseña"
                                    className={cx('login-input')}
                                    type="password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <div />
                            </div>
                        </div>
                        <Button disabled={authLoadingStatus} type="rounded" className={cx('login-btn')}>
                            Iniciar sesión
                        </Button>
                        <p className={cx('accent', 'reset-pwd')} onClick={() => changePage('?auth=reset-password')}>
                            ¿Olvidaste tu contraseña?
                        </p>
                        <div className={cx('sign-up-option')}>
                            <p>¿No tienes cuenta?</p>
                            <p className={cx('accent')} onClick={() => changePage('?auth=signup')}>
                                Regístrate gratis
                            </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
Login.propsType = {
    onClose: PropsType.func.isRequired,
    changePage: PropsType.func.isRequired,
};
export default Login;
